import { render, staticRenderFns } from "./wb-widget-props.vue?vue&type=template&id=69139e91&scoped=true"
import script from "./wb-widget-props.vue?vue&type=script&lang=js"
export * from "./wb-widget-props.vue?vue&type=script&lang=js"
import style0 from "./wb-widget-props.vue?vue&type=style&index=0&id=69139e91&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69139e91",
  null
  
)

export default component.exports